export default "__VITE_ASSET__DP3vdX6n__"